const ROUTE_CONSTANTS = {
	BASE: '/',
	BSECURE_MALL: '/bsecure-mall',
	LOADING: '/loading',
	PRODUCT_DETAIL: '/product',
	CART: '/cart',
	ERROR_PAGE: '/error',
	ERROR_PAGE_ANY: '/error:',
	ABOUT_US: '/about',
	PRIVACY_POLICY: '/privacy',
	STATUS: `/status`,
	ANY: '**',
}

const ARRAY_ROUTE_CONSTANTS = [
	ROUTE_CONSTANTS.BASE,
	ROUTE_CONSTANTS.LOADING,
	ROUTE_CONSTANTS.CART,
	ROUTE_CONSTANTS.PRODUCT_DETAIL,
	ROUTE_CONSTANTS.ERROR_PAGE,
	ROUTE_CONSTANTS.BSECURE_MALL,
	ROUTE_CONSTANTS.ABOUT_US,
	ROUTE_CONSTANTS.STATUS,
]
export { ROUTE_CONSTANTS, ARRAY_ROUTE_CONSTANTS }
